import React from 'react'
import { Box, Text, Group, UnstyledButton } from '@mantine/core'
import { useAirdrop } from '../AirdropProvider'

const AirdropGuideLink = () => {
  const { setScreen } = useAirdrop()

  const handleClick = () => {
    setScreen('landing')
  }

  return (
    <Group position="apart">
      <Box />

      <UnstyledButton onClick={handleClick}>
        <Text sx={(t) => ({ color: t.colors.gray[7] })}>How does this work? &rarr;</Text>
      </UnstyledButton>
    </Group>
  )
}

export { AirdropGuideLink }
